import { h, Component } from 'preact'
import { connect } from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import util from '../util';
import store from "../store";

import Renderer from '../canvas/renderer'

import FlipWidget from './FlipWidget'
import PositionTools from './PositionTools'
import ResizeWidget from './ResizeWidget'
import constants from "../constants";
import { deselectAll } from '../canvas/selection';
import GroupBarListItem from "./GroupBarListItem";
import {canDisplayAlign} from "../canvas/component";
import { UnlockOutlined, LockOutlined, DeleteOutlined, DownOutlined } from "@ant-design/icons";
import TextGraphicAnimations from './TextGraphicAnimations';

export default @connect(reduce, actions)
class IllustrationBar extends Component {
  constructor() {
    super();

    this.state = {
      customColor: '',
      illustrationId: '',
      isEditTemplateColorsModal: false
    };

    this.ungroup = () => {
      Renderer.ungroup(this.props.$element);
    };

    this.removeElement = () => {
      this.props.deselect();
      Renderer.remove(this.props.isMultiSelect ? this.props.$elements : this.props.$element, this.props.isMultiSelect);
    };

    this.updateOpacity = (ev) => {
      const val = ev.target.value;
      const $elem = util.getElementContent(this.props.$element);

      Renderer.updateElementStyle($elem, 'opacity', val / 100);
      this.props.updateElementAttribute('opacity', val);
    };

    this.copyElement = () => {
      Renderer.copy(this.props.isMultiSelect ? this.props.$elements : this.props.$element);
    };

    this.copyGroup = () => {
      Renderer.copy(this.props.$element?.parents('.group'));
    };

    this.componentDidMount = () => {
      this.initConfig();
    };

    this.componentDidUpdate = () => {
      this.initConfig();
    };

    this.initConfig = () => {
      let illustrationId;
      if (this.props.$element !== null) {
        illustrationId = this.props.$element?.attr('id');
      } else {
        deselectAll();
        return;
      }
      if (this.props.illustrationConfig && Object.entries(this.props.illustrationConfig).length > 0 && this.state.illustrationId !== illustrationId) {
        this.setState({ illustrationId: illustrationId });
      }
    };

    this.toggleLock = () => {
      const $elements = this.props.isMultiSelect ? this.props.$elements : this.props.$element;
      if (this.props.isLocked) {
        Renderer.unlock($elements);
      } else {
        Renderer.lock($elements);
      }
      this.props.updateElementAttribute('isLocked', !this.props.isLocked);
    }

    this.openColorPicker = (type, config) => {
      util.openColorPicker([type, config]);
    }
    
    this.openAnimations = () => {
      util.openAnimations();
    }
  }

  render(props, state) {
    const asideView = store.getState().view;

    const config = props.illustrationConfig && Object.entries(props.illustrationConfig).length > 0 ? props.illustrationConfig.map((config, idx) => {
      return (
        <li>
          <a className={props.isMobileVersion ? 'mobile-tool-widget' : ''} style={`display: flex; align-items: center; justify-content: center;`} onClick={() => this.openColorPicker(constants.pickerTypes.illustrationSwatch, config)}>
            <span className="color-box" style={`background: ${config.color}; float: none;`}></span>
            {props.isMobileVersion && <span>Color {idx + 1}</span>}
          </a>
        </li>
      )}) : '';

    const copyOptions = props.isInGroup ?
      <a className={!props.isMobileVersion ? 'icn rwd-icon hint--bottom' : 'mobile-tool-widget'} data-hint="Duplicate" onClick={this.copyGroup}>
        <svg>
          <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-copy"} />
        </svg>
        {props.isMobileVersion && <span>Copy</span>}
      </a> :
      <a className={!props.isMobileVersion ? 'icn rwd-icon hint--bottom' : 'mobile-tool-widget'} data-hint="Duplicate" onClick={this.copyElement}>
        <svg>
          <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-copy"} />
        </svg>
        {props.isMobileVersion && <span>Copy</span>}
      </a>;

    const elementOptions = !props.isLocked ?
      <ul className="secondary">
        <li className={!props.isInGroup ? 'hidden' : ''}>
          <a className="icn rwd-icon ungroup-btn" onClick={this.ungroup}>
            <span>Ungroup</span>
          </a>
        </li>

        {props.multiselect && <GroupBarListItem {...props} />}

        {canDisplayAlign(props.$element) && <li>
          <PositionTools />
        </li>}

        {/*<li>
          <HyperlinkWidget $element={props.$element} href={props.href} isHyperlink={props.isHyperlink} updateElementAttribute={props.updateElementAttribute} hasPdfPermission={props.hasPdfPermission} setActiveMember={props.setActiveMember} />
        </li>*/}
        
        {!props.isMobileVersion && <span className="separator"></span>}

        {!props.isMobileVersion && <li>
          {copyOptions}
        </li>}

        <li>
          <a className={!props.isMobileVersion ? 'icn rwd-icon hint--bottom' : 'mobile-tool-widget'} data-hint="Lock" onClick={this.toggleLock}>
            <UnlockOutlined />
            {props.isMobileVersion && <span>Lock</span>}
          </a>
        </li>
        {!props.isMobileVersion &&
          <li>
            <a className="rwd-icon hint--bottom" data-hint="Delete" onClick={this.removeElement}>
              <DeleteOutlined />
            </a>
          </li>}
      </ul>
      :
      <ul className="secondary">
        <li>
          <a className={!props.isMobileVersion ? 'icn tgl act rwd-icon hint--bottom' : 'act mobile-tool-widget'} data-hint="Unlock" onClick={this.toggleLock}>
            <LockOutlined />
            {props.isMobileVersion && <span>Unlock</span>}
          </a>
        </li>
        <li>
          <a className="locked-label hint--bottom" data-hint="Unlock" onClick={this.toggleLock}>Locked</a>
        </li>
      </ul>;

    return (
      <div className="context-bar">
        <ul>
          {/* {props.isMobileVersion &&
            <li>
              <a className="mobile-tool-widget" data-hint="Delete" onClick={this.removeElement}>
                <DeleteOutlined />
                <span>Delete</span>
              </a>
            </li>} */}

          {!props.multiselect && config}
          {!props.multiselect && !props.isMobileVersion && <span className="separator"></span>}
          {!props.multiselect && <li>
            <div className="dropdown sizes">
              <a className={`dropdown-toggle ${!props.isMobileVersion ? 'icn rwd-icon hint--bottom' : 'mobile-tool-widget'}`} data-hint="Opacity">
                <svg>
                  <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-opacity"} />
                </svg>
                {props.isMobileVersion && <span>Opacity</span>}
              </a>
              <div className="dropdown-menu auto" data-close="no">
                {props.isMobileVersion && <div className="mobile-dropdown-header">
                  <span>Opacity</span>
                  <div className="dropdown-toggle"><DownOutlined/></div>
                </div>}
                <ul className="slider-list">
                  <li className="slider-item">
                    <div className={'slider-wrap'}>
                      <label>Opacity</label>
                      <div className="toolbar-wrap">
                        <input className="slider" type="range" min="0" max="100" step="1" value={props.opacity} onChange={this.updateOpacity} onMouseMove={this.updateOpacity} />
                      </div>
                      <input className="value" type="number" min="0" max="100" step="1" disabled="disabled" value={Math.round(props.opacity)} />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </li>}

          {!props.multiselect && !props.isMobileVersion && <span className="separator"></span>}

          {!props.multiselect && <li><FlipWidget/></li>}

          {!props.multiselect && !props.isMobileVersion && (props.isAdmin || props.isDesigner) && <span className="separator"></span>}
          
          {(props.isAdmin || props.isDesigner) && <li>
            <ResizeWidget />
          </li>}

          {!props.isMobileVersion && <li className={'hideThirdSet'}>
            <a className={`${asideView === 'animations' || props.isAnimated ? "text-effect-active" : ""}`} onClick={this.openAnimations}>
              <span>Animate</span>
            </a>
          </li>}

          {props.isMobileVersion && <li className='hideThirdSet'>
            <div className="dropdown sizes effect-animation-mobile">
              <a className={`dropdown-toggle ${props.isAnimated ? "text-effect-active" : ""} mobile-tool-widget`}>
                <svg><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-animations"} /></svg>
                <span>Animate</span>
              </a>

              <div className="dropdown-menu right" data-close="no">
                {props.isMobileVersion && <div className="mobile-dropdown-header">
                  <span>Animate</span>
                  <div className="dropdown-toggle"><DownOutlined /></div>
                </div>}
                <div className="option-container" style="height: 50vh; overflow: auto;">
                  <TextGraphicAnimations/>
                </div>
              </div>
            </div>
          </li>}
        </ul>

        {elementOptions}
      </div>
    )
  }
}
